import { cn } from "@/lib/utils";
import { getJobApplicationStatusMeta } from "@/lib/job-status";

type JobApplicationStatusBadgeProps = {
  status?: string | null;
  className?: string;
  size?: "sm" | "md";
};

export function JobApplicationStatusBadge({
  status,
  className,
  size = "sm",
}: JobApplicationStatusBadgeProps) {
  const meta = getJobApplicationStatusMeta(status);
  const Icon = meta.icon;
  const sizing = size === "md" ? "px-3 py-1 text-sm" : "px-2 py-0.5 text-xs";
  const iconSize = size === "md" ? "h-4 w-4" : "h-3.5 w-3.5";

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border font-medium",
        meta.className,
        sizing,
        className
      )}
      title={meta.label}
    >
      <Icon className={cn(iconSize, "mr-1.5 shrink-0")} />
      <span className="truncate">{meta.label}</span>
    </span>
  );
}
